export const AUTH_CODE_LENGTH = 6;

export default function codeSanitize(value: string): string {
    return value.replace(/\D/g, '').slice(0, AUTH_CODE_LENGTH);
}
